//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "BasicSettings",
	props: {
		settings: Object
	},
	watch: {
		settings: function settings(newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal) {
					this.data = newVal;
					this.settingsDataLoading = false;
					this.data.fee_managed = this.data.general_settings.fee_managed == 1;
					this.data.vintage = this.data.general_settings.vintage;
					this.data.class = this.data.general_settings.class;
					this.data.region = this.data.general_settings.region;
				}
			}
		}
	},
	data: function data() {
		return {
			modalName: 'basic-settings',
			editing: false,
			settingsDataLoading: true,
			data: {
				name: '',
				legal_name: '',
				acct: '',
				email: '',
				phone: '',
				speed_dial: '',
				fax: '',
				address: '',
				address2: '',
				city: '',
				state: '',
				postal: '',
				url: '',
				manager_name: '',
				manager_phone: '',
				fee_managed: false
			},
			roleForEditSettings: ['super-admin', 'corporate-admin', 'accounting-admin']
		};
	},
	mounted: function mounted() {
		var _this = this;

		Event.$on('basic-settings', function () {
			Event.$emit('open-slide', _this.modalName);
		});

		Event.$on('close-slide', function () {
			_this.editing = false;
		});
	},

	methods: {
		cancel: function cancel() {
			Event.$emit('close-slide', this.modalName);
		},
		save: function save() {
			var _this2 = this;

			axios.post('/prototype/properties/' + this.$store.state.selectedProperty + "/settings", {
				data: this.data
			}).then(function (response) {
				_this2.data = response.data;
				_this2.data.fee_managed = response.data.general_settings.fee_managed == 1;
				_this2.data.vintage = response.data.general_settings.vintage;
				_this2.data.class = response.data.general_settings.class;
				_this2.data.region = response.data.general_settings.region;
			}).then(function (response) {
				Event.$emit('close-slide', _this2.modalName);
				Event.$emit('refresh-property-menu');
			}).then(function (response) {
				_this2.$snotify.success("Changes saved successfully.");
			});
		},
		canUserEditSettings: function canUserEditSettings() {
			return this.roleForEditSettings.includes(window.validator.role());
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/BasicSettings.vue
// module id = Xvu2
// module chunks = 0 1